var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import planList from '../../components/repayment/single-import-plan-list.vue';
import planCreate from '../../components/repayment/single-import-plan-create.vue';
export default Vue.extend({
    data: function () {
        return {
            isEffective: true,
            ableAmout_: 0,
            isAddTips: false,
            amountTypesArr: [],
            createTitle: '',
            sureBtn: '',
            completeList: null,
            createTableData: [{}],
            batchTableData: [
                {
                    amountTypeText: '租金/月供',
                    amount: 'amount',
                    mode: 'mode',
                    date: 'date',
                },
            ],
            singleTableData: [
                {
                    amount: 'amount',
                    mode: 'mode',
                    date: 'date',
                },
            ],
            amountTypes: [
                {
                    val: 'MONTHLY_RENT',
                    label: '租金/月供',
                },
                {
                    val: 'PUNISHMENT',
                    label: '违章罚款',
                },
                {
                    val: 'DEPOSIT',
                    label: '押金',
                },
                {
                    val: 'MANAGEMENT',
                    label: '管理费',
                },
                {
                    val: 'INSURANCE',
                    label: '保险',
                },
            ],
        };
    },
    computed: __assign({}, mapState('contract', {
        contractData: 'contractDetailVague',
    }), mapState(['repayment']), { newPlanAmount: function () {
            return this.$utils.toYuan(this.contractData.newPlanAmount);
        },
        signStatus: function () {
            return this.contractData.signStatus;
        },
        repayEndTime: function () {
            return this.contractData.repayEndTime;
        },
        isCreate: function () {
            return this.repayment.isCreate;
        },
        isDisabledAddBatch: function () {
            return this.repayment.isDisabledAddBatch;
        },
        alreadyCreateNewPlanAmount: function () {
            return this.repayment.alreadyCreateNewPlanAmount;
        } }),
    components: {
        'el-plan-create': planCreate,
        'el-plan-list': planList,
    },
    created: function () { },
    mounted: function () { },
    methods: {
        closeAddTips: function () {
            this.isAddTips = false;
        },
        isEffeciveF: function (date) {
            if (date === '')
                return;
            var current = new Date();
            var currentMs = new Date(current.getFullYear(), current.getMonth(), current.getDate()).getTime();
            var InputDateArr = date.split(' ')[0].split('-');
            var inputMs = new Date(InputDateArr[0], InputDateArr[1] - 1, InputDateArr[2]).getTime();
            this.isEffective = inputMs < currentMs ? false : true;
        },
        openSingle: function () {
            var singleTableData = this.singleTableData;
            this.amountTypes[0].disabled =
                this.$utils.toFen(this.newPlanAmount) -
                    this.$utils.toFen(this.alreadyCreateNewPlanAmount) <=
                    0 || false;
            this.amountTypesArr = this.amountTypes.slice();
            this.createTitle = '添加单个还款计划';
            this.createTableData = singleTableData;
            this.sureBtn = '';
            this.$store.commit('repayment/update', { isOpenCreate: true });
        },
        openBatch: function () {
            var _a = this.contractData, newPlanAmount = _a.newPlanAmount, leaseMode = _a.leaseMode, signStatus = _a.signStatus;
            var _b = this, isEffective = _b.isEffective, batchTableData = _b.batchTableData;
            if (newPlanAmount <= 0) {
                this.$message({
                    message: '可用金额不足',
                    type: 'warning',
                });
                return;
            }
            if (this.repayment.isHasEdit) {
                this.$message({
                    message: '您当前有编辑状态的还款计划，请先保存后再试',
                    type: 'warning',
                });
                return;
            }
            this.createTitle = '批量生成还款计划';
            this.createTableData = batchTableData;
            this.sureBtn = '批量生成';
            this.$store.commit('repayment/update', { isOpenCreate: true });
        },
        createList: function (_a) {
            var completeList = _a.completeList;
            this.completeList = completeList;
        },
    },
});
